import { ArrowLeft03Icon } from "hugeicons-react";
import { useResourceContext } from '../../contexts/ResourceContext';
import { useWindow } from "../../contexts/WindowContext";

export const ResourcesButton = () => {
  const { showResourcesButton, openResources } = useResourceContext();
  const { windowWidth } = useWindow();

  if (windowWidth < 768) return null;

  if (!showResourcesButton) return null;
  return (
    <button
      type="button"
      onClick={openResources}
      aria-label="Show Resources"
      className="p-2 rounded-xl transition-colors"
      style={{
        backgroundColor: "transparent",
        color: "var(--text-primary)",
      }}
      onMouseEnter={e => {
        e.currentTarget.style.backgroundColor = "var(--background-hover)";
      }}
      onMouseLeave={e => {
        e.currentTarget.style.backgroundColor = "transparent";
      }}
    >
      <ArrowLeft03Icon size={23} />
    </button>
  );
};